module.exports = __webpack_public_path__ + "img/4.8eba15b0.png";